export default __webpack_public_path__ + "static/media/ex-register.61f3e1a9.jpg";